export default {
  FETCHED_ALL: 'FETCHED_ALL_MARKETS',
  FETCHED_MULTIPLE: 'FETCHED_MARKETS',
  FETCHED_SINGLE: 'FETCHED_MARKET',
  DELETED_SINGLE: 'DELETED_MARKET',
};
